// src/features/medicine/medicineSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  getTopDoctorsByLocationId,
  getTopDoctorsByMedicineId,
  getTopMedicinesByLocationId,
} from "../../../api/general/generalThunk";
import { createAsyncCases } from "../../../helpers/reduxUtils";
const initialState = {
  topDoctorsByMedId: null,
  topDoctorsByLocationId: null,
  topMedicinesByLocationId: null,
};
const generalSlice = createSlice({
  name: "general",
  initialState,
  reducers: {
    handleSelectedItem: (state, action) => {
    },
  },
  extraReducers: (builder) => {
    createAsyncCases(builder, getTopDoctorsByMedicineId, {
      fulfilled(state, action) {
        state.topDoctorsByMedId = action.payload;
      },
    });
    createAsyncCases(builder, getTopDoctorsByLocationId, {
      fulfilled(state, action) {
        state.topDoctorsByLocationId = action.payload;
      },
    });
    createAsyncCases(builder, getTopMedicinesByLocationId, {
      fulfilled(state, action) {
        state.topMedicinesByLocationId = action.payload;
      },
    });
  },
});
export const { handleSelectedItem } = generalSlice.actions;
export default generalSlice.reducer;
